import { Box } from "@mui/material";
import { ZonedTimeRange } from "types/ZonedTimeRange";
import { luxonUtils } from "utils/luxonUtils";

export interface SchedulePeriodsProps {
    zonedTimeRanges?: ZonedTimeRange[];
    showInUserLocalTime: boolean;
}

const unknownConstant = "N/A";

function FormatDateTimeOffset(props: {
    timeFormat: string;
    dateFormat: string;
    value: string;
    showInUserLocalTime: boolean;
}) {
    if (!props.value) {
        return unknownConstant;
    }

    let dateTimeOffset = luxonUtils.fromNodaTimeZonedDateTime(props.value);

    if (props.showInUserLocalTime) {
        dateTimeOffset = dateTimeOffset.toLocal();
        return (
            <>
                {dateTimeOffset.toFormat(props.timeFormat)}{" "}
                <span style={{ color: "grey" }}>
                    [{dateTimeOffset.toFormat(props.dateFormat)}]
                </span>
            </>
        );
    }
    return <>{dateTimeOffset.toFormat(props.timeFormat)}</>;
}

export default function SchedulePeriods(props: SchedulePeriodsProps) {
    if (!props.zonedTimeRanges || props.zonedTimeRanges.length === 0) {
        return unknownConstant;
    }

    return (
        <>
            {props.zonedTimeRanges.map((zonedTimeRange, index) => (
                <Box
                    key={index}
                    sx={{ whiteSpace: "nowrap" }}
                >
                    <FormatDateTimeOffset
                        timeFormat="HH:mm"
                        dateFormat="dd-MM"
                        value={zonedTimeRange.start}
                        showInUserLocalTime={props.showInUserLocalTime}
                    />
                    &nbsp;-&nbsp;
                    <FormatDateTimeOffset
                        timeFormat="HH:mm"
                        dateFormat="dd-MM"
                        value={zonedTimeRange.end}
                        showInUserLocalTime={props.showInUserLocalTime}
                    />
                </Box>
            ))}
        </>
    );
}
